import script from "./tenantindex.vue?vue&type=script&setup=true&lang=js"
export * from "./tenantindex.vue?vue&type=script&setup=true&lang=js"

import "./tenantindex.vue?vue&type=style&index=0&id=33cdf83c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33cdf83c"]])

export default __exports__